import { getBackendUrl } from "../config";

export function getGreetingMediaPublicUrl(filename, companyId) {
  if (!filename || companyId == null || companyId === "") return "";
  const backend = String(getBackendUrl() || window.location.origin)
    .replace(/\/api\/?$/, "")
    .replace(/\/$/, "");
  const safeName = String(filename).split("/").pop();
  return `${backend}/public/company${companyId}/${encodeURIComponent(safeName)}`;
}

export function isGreetingMediaVideo(nameOrFile) {
  const name =
    typeof nameOrFile === "string"
      ? nameOrFile
      : nameOrFile?.name || nameOrFile?.type || "";
  if (typeof name === "string" && name.startsWith("video/")) return true;
  return /\.(mp4|webm|mov|avi|mkv|m4v|3gp)$/i.test(String(name));
}

export function revokeObjectUrlIfBlob(url) {
  if (url && String(url).startsWith("blob:")) {
    URL.revokeObjectURL(url);
  }
}
